/**
 * Base template — foundation for all industry templates.
 * mergeTemplate() deep-merges overrides with this base.
 */

export const baseTemplate = {
  settings: {
    primaryColor: '#134e4a',
    accentColor: '#d97706',
    darkMode: false,
    fontStack: 'system',
    stylePreset: 'signature',
    designDensity: 'balanced',
    generateImpressum: true,
    generateDatenschutz: true,
    generateAngebot: true,
    generateMethoden: true,
    generateUeberMich: true,
    trackingPreset: 'none',
    pageAngebot: {
      heroTitle: 'Unsere Leistungen',
      heroSubtitle: 'Professionelle Dienstleistungen f\u00fcr Ihre Bed\u00fcrfnisse',
      packages: [
        {
          name: 'Basis',
          price: 'auf Anfrage',
          description: 'Grundlegendes Angebot',
          features: 'Beratung, Analyse, Umsetzung',
          highlighted: false,
        },
        {
          name: 'Premium',
          price: 'auf Anfrage',
          description: 'Erweitertes Angebot',
          features: 'Alles aus Basis, Betreuung, Support, Reporting',
          highlighted: true,
        },
        {
          name: 'Enterprise',
          price: 'auf Anfrage',
          description: 'Massgeschneiderte L\u00f6sung',
          features: 'Alles aus Premium, SLA, Dedizierter Ansprechpartner',
          highlighted: false,
        },
      ],
      ctaTitle: 'Bereit f\u00fcr den n\u00e4chsten Schritt?',
      ctaText: 'Kontaktieren Sie uns f\u00fcr eine unverbindliche Beratung.',
      ctaButtonText: 'Kontakt aufnehmen',
    },
    pageMethoden: {
      heroTitle: 'Unsere Methodik',
      heroSubtitle: 'Strukturiert, transparent, wirksam',
      introText:
        'Wir arbeiten nach bew\u00e4hrten Methoden und setzen auf Transparenz in jedem Schritt.',
      steps: [
        { title: 'Analyse', description: 'Gr\u00fcndliche Bestandsaufnahme und Bedarfsanalyse' },
        { title: 'Konzept', description: 'Massgeschneiderte Strategie und Planung' },
        { title: 'Umsetzung', description: 'Professionelle Durchf\u00fchrung mit regelm\u00e4ssigen Updates' },
        { title: 'Ergebnis', description: 'Qualit\u00e4tskontrolle und nachhaltige Ergebnisse' },
      ],
      tools: [
        { name: 'Digitale Tools', description: 'Moderne Software f\u00fcr effiziente Prozesse' },
        { name: 'Qualit\u00e4tssicherung', description: 'Systematische Pr\u00fcfung in jeder Phase' },
        { name: 'Reporting', description: 'Transparente Dokumentation und Fortschrittsberichte' },
      ],
      philosophyTitle: 'Unsere Philosophie',
      philosophyText:
        'Qualit\u00e4t, Verl\u00e4sslichkeit und pers\u00f6nliche Betreuung stehen bei uns im Mittelpunkt.',
    },
    pageUeberMich: {
      heroTitle: '\u00dcber uns',
      heroSubtitle: 'Erfahrung trifft Engagement',
      introText:
        'Seit Jahren sind wir Ihr verl\u00e4sslicher Partner. Lernen Sie unser Team und unsere Werte kennen.',
      imageUrl: '',
      timeline: [
        { year: 'Gr\u00fcndung', text: 'Start des Unternehmens' },
        { year: 'Wachstum', text: 'Erweiterung des Angebots' },
        { year: 'Heute', text: 'Ihr kompetenter Partner in der Region' },
      ],
      values: [
        { title: 'Qualit\u00e4t', description: 'H\u00f6chste Standards in allem, was wir tun' },
        { title: 'Vertrauen', description: 'Langfristige Partnerschaften auf Augenh\u00f6he' },
        { title: 'Innovation', description: 'Modernste Ans\u00e4tze f\u00fcr beste Ergebnisse' },
      ],
      certifications: '',
    },
  },
  components: {
    header: {
      companyName: 'Muster AG',
      logoText: 'MA',
      navItems: ['Leistungen', 'Methoden', 'Team', 'Kontakt'],
      ctaText: 'Kontakt',
    },
    hero: {
      title: 'Ihr Partner f\u00fcr Qualit\u00e4t.',
      subtitle:
        'Professionelle Dienstleistungen f\u00fcr Schweizer Unternehmen und Privatpersonen.',
      primaryBtn: 'Kontakt aufnehmen',
      secondaryBtn: 'Leistungen',
      imageUrl: '',
    },
    trust: {
      items: [
        { value: 'Erfahren', label: 'Team' },
        { value: 'Zuverl\u00e4ssig', label: 'Service' },
        { value: 'Lokal', label: 'Verankert' },
        { value: 'Pers\u00f6nlich', label: 'Beratung' },
      ],
    },
    services: {
      title: 'Leistungen',
      subtitle: 'Was wir f\u00fcr Sie tun.',
      items: [
        { icon: '\u{1F4CB}', title: 'Beratung', text: 'Individuelle Analyse und Empfehlung.' },
        { icon: '\u2699\uFE0F', title: 'Umsetzung', text: 'Professionelle Durchf\u00fchrung.' },
        { icon: '\u{1F3AF}', title: 'Ergebnis', text: 'Messbare Resultate und Nachbetreuung.' },
      ],
    },
    testimonials: {
      title: 'Kundenstimmen',
      items: [
        {
          quote: 'Sehr professionell und zuverl\u00e4ssig. Jederzeit wieder.',
          author: 'Zufriedener Kunde',
          role: '',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      subtitle: '',
      items: [
        {
          question: 'Wie kann ich Sie kontaktieren?',
          answer: 'Telefonisch, per E-Mail oder \u00fcber das Kontaktformular.',
        },
      ],
    },
    cta: {
      title: 'Kontakt aufnehmen',
      subtitle: 'Wir freuen uns auf Ihre Anfrage.',
      phone: '+41 00 000 00 00',
      email: 'info@example.ch',
    },
    cookie: {
      title: 'Cookie-Einstellungen',
      text: 'Wir verwenden Cookies, um Ihnen die bestm\u00f6gliche Erfahrung zu bieten.',
      acceptAll: 'Alle akzeptieren',
      acceptNecessary: 'Nur notwendige',
      acceptReject: 'Ablehnen',
      openSettings: 'Einstellungen',
      policyLink: 'datenschutz.html',
      showSettingsButton: true,
      defaultMarketing: false,
      defaultStatistics: false,
      manageLinkText: 'Cookie-Einstellungen',
      preferencesText: 'W\u00e4hlen Sie aus, welche Cookies wir verwenden d\u00fcrfen. Notwendige Cookies sind immer aktiv.',
      preferencesTitle: 'Cookie-Einstellungen',
      marketingLabel: 'Marketing',
      statisticsLabel: 'Statistik',
      necessaryLabel: 'Notwendig',
      savePreferences: 'Speichern',
    },
    footer: {
      companyName: 'Muster AG',
      tagline: 'Ihr Partner in der Region.',
      address: 'Musterstrasse 1, 8000 Z\u00fcrich',
      phone: '+41 00 000 00 00',
      email: 'info@example.ch',
    },
  },
};

export interface TemplateOverrides {
  name: string;
  icon: string;
  settings?: Record<string, any>;
  components?: Record<string, any>;
}

export interface IndustryTemplate {
  name: string;
  icon: string;
  settings: Record<string, any>;
  components: Record<string, any>;
}

export function mergeTemplate(overrides: TemplateOverrides): IndustryTemplate {
  const result: IndustryTemplate = {
    name: overrides.name,
    icon: overrides.icon,
    settings: {},
    components: {},
  };

  // Merge settings (shallow + deep for page objects)
  const bs = baseTemplate.settings as Record<string, any>;
  const os = (overrides.settings || {}) as Record<string, any>;
  result.settings = Object.assign({}, bs, os);

  // Deep merge page sub-objects
  ['pageAngebot', 'pageMethoden', 'pageUeberMich'].forEach((key) => {
    result.settings[key] = Object.assign({}, bs[key] || {}, os[key] || {});
  });

  // Merge components (shallow per component)
  const bc = baseTemplate.components as Record<string, any>;
  const oc = (overrides.components || {}) as Record<string, any>;
  Object.keys(bc).forEach((key) => {
    result.components[key] = Object.assign({}, bc[key], oc[key] || {});
  });

  // Add components that only exist in overrides (e.g. team, benefits)
  Object.keys(oc).forEach((key) => {
    if (!bc[key]) {
      result.components[key] = oc[key];
    }
  });

  return result;
}
